
const settings = {
    backend: window.backendUrl
    //backend: 'https://digitaleventbe.ekapps.tech'
};
console.log(process.env.BACKEND_URL);

export default settings;